import { differenceInDays, parseISO } from 'date-fns';
import { ReactNode } from 'react';

export const resultTitleMap = (totalScore: number, totalQuestions: number) => {
  let title: ReactNode = null;
  let subtitle = 'To complete this skill, earn at least 4 out of 5';

  const score = totalScore / 2;

  switch (totalScore) {
    case 0:
    case 2:
      title = (
        <>
          Not there yet, you got{' '}
          <span className="tw-font-bold">
            {score} out of {totalQuestions}
          </span>
        </>
      );
      break;

    case 4:
      title = (
        <>
          Getting there, you got{' '}
          <span className="tw-font-bold">
            {score} out of {totalQuestions}
          </span>
        </>
      );
      break;

    case 6:
      title = (
        <>
          Almost there, you got{' '}
          <span className="tw-font-bold">
            {score} out of {totalQuestions}
          </span>
        </>
      );
      break;

    case 8:
      title = (
        <>
          <span className="tw-font-bold">Got it!</span> You got{' '}
          <span className="tw-font-bold">
            {score} out of {totalQuestions}
          </span>
        </>
      );
      subtitle = 'You’ve passed this skill with 4/5';
      break;

    case 10:
      title = (
        <>
          <span className="tw-font-bold">Perfect score,</span> great job!
        </>
      );
      subtitle = 'You got all 5 questions right in this skill';
      break;
  }

  return { title, subtitle };
};

export const getMotivationalMessage = (totalScore: number) => {
  let motivationalMessage: ReactNode = null;

  const randomMessages = [
    <>
      Skills take time. <span className="tw-font-bold"> A bit of practice </span> can change everything
    </>,
    <>
      Sometimes <span className="tw-font-bold"> a side step </span> helps you move forward
    </>,
    <>
      <span className="tw-font-bold">Keep going</span> —every attempt makes you stronger
    </>,
    <>
      <span className="tw-font-bold">A quick side step</span>can open the way to success.
    </>,
  ];

  if (totalScore === 0 || totalScore === 2) {
    motivationalMessage = randomMessages[Math.floor(Math.random() * randomMessages.length)];
  }

  if (totalScore === 4) {
    motivationalMessage = (
      <>
        <span className="tw-font-bold">2 down, 2 to go. </span> Practice can help!
      </>
    );
  }

  if (totalScore === 6) {
    motivationalMessage = (
      <>
        <span className="tw-font-bold">Only 1 more answer</span> to pass the skill
      </>
    );
  }

  if (totalScore === 8) {
    motivationalMessage = (
      <>
        Nicely done!<span className="tw-font-bold"> You can now move forward!</span>
      </>
    );
  }

  if (totalScore === 10) {
    motivationalMessage = (
      <>
        You nailed it! <span className="tw-font-bold">Your understanding is spot on.</span>
      </>
    );
  }

  return { motivationalMessage };
};

export const isMoreThan30DaysAgo = (sessionCompletedOn: string): boolean => {
  const completedDate = parseISO(sessionCompletedOn);
  return differenceInDays(new Date(), completedDate) > 30;
};
